import { CSSObject } from '@chakra-ui/react';
import { KeypadSchema } from '@/components/Betslip/components/Keyboard/styles/Keypad.styles';

export const keypadStyles: KeypadSchema = {
  buttonActionProps: {
    borderRadius: 'md',
    color: 'white',
    border: '2px solid',
    borderColor: 'alpha.50',
  },
};

export const FlexKeypadWrapper: CSSObject = {
  bg: 'alpha.800',
};

export const ButtonKeys = (isBatch: boolean): CSSObject => ({
  color: 'white',
  bgGradient: 'linear(180deg, alpha.500, alpha.600)',
  boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
  borderRadius: 'md',
  border: 'none',
  bg: 'none',

  ...(isBatch && {
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.25)',
    color: 'blackAlpha.600',
  }),
  '&.keypad-btn-done': {
    color: 'blackAlpha.600',
    _disabled: {
      bgGradient: 'linear(to-b, beta.400, beta.500)',
      color: 'blackAlpha.600',
    },
    textTransform: 'uppercase',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    boShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    fontSize: 'md',
  },
});
